module.exports = __webpack_public_path__ + "static/books-site-mobile-11f79a9d7be3ae9c82caf9fe4889ec2c.jpg";